import { formatMoney } from 'common'

import { parseZoneFormat } from 'common/dateFormatters'

import RunoutDaysCircle from '../../../employeeDashboard/perks/home/perksAllowance/categoryAllowanceCard/RunoutDaysCircle'

import './styles.less'

const CategoryInformation = ({
  monthlyAllowanceValue,
  type,
  startDate,
  endDate,
  benefitEndDate,
  runOutDays,
  daysToRunOut,
  isContinuous,
}) => {
  const data = [
    { title: 'Allowance', value: <div> {formatMoney(monthlyAllowanceValue, true)}</div> },
    { title: 'Frequency', value: <div>{type}</div> },
    { title: 'Start Date', value: <div>{parseZoneFormat(startDate)}</div> },
    {
      title: 'End Date',
      value: <div>{isContinuous ? 'Continuous' : parseZoneFormat(endDate)}</div>,
    },
  ].concat(
    daysToRunOut > 0
      ? {
          title: 'Days to run out',
          value: (
            <div>
              <RunoutDaysCircle daysToRunOut={daysToRunOut} runOutDays={runOutDays} />
            </div>
          ),
        }
      : [],
  )
  return (
    <>
      {data.map(({ title, value }) => (
        <>
          <hr className="line_style mb-12" />
          <div className="flex__space_between mb-12">
            <div className="color-gray-7">{title}</div>
            {value}
          </div>
        </>
      ))}
      <hr className="line_style mb-12" />
    </>
  )
}

export default CategoryInformation
